import { render, staticRenderFns } from "./APIGateway.vue?vue&type=template&id=50196542"
import script from "./APIGateway.vue?vue&type=script&lang=js"
export * from "./APIGateway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports